/* global RdcTracking */

export const trackSave = function(saveItem, saveAction, listingId='unknown', omtag='') {
  const props = {
    saveItem,
    saveAction,
    listingId,
  }
  const omtagItem = omtag? omtag : 'savedItem' 
  RdcTracking.trackEvent(omtagItem, props);
};



// WEBPACK FOOTER //
// ./shared_critical/tracking/shared/saves.js